import { useEffect, useState } from 'react';

export const usePercentages = ({ all, circleRef, parentWidth }) => {
    const [circleLength, setCircleLength] = useState(1);
    const [percentagePrimary, setPercentagePrimary] = useState(0);
    const [percentageSecondary, setPercentageSecondary] = useState(0);

    useEffect(() => {
        if (typeof all !== 'number') return;

        const percentage = Math.ceil(all * 100);

        setPercentagePrimary(percentage);

        if (!circleRef) return;

        const { length } = circleRef.getClientRects();
        const isNonRenderedElement = length === 0;

        if (isNonRenderedElement) return;

        const circleLength = Math.round(circleRef.getTotalLength());
        /** only half a circle is used so divide circleLength on 2 */
        const percentageCircle = Math.round((circleLength / 2 / 100) * percentage);

        setCircleLength(circleLength);
        setPercentageSecondary(percentageCircle);
    }, [circleRef, parentWidth, all]);

    return {
        circleLength,
        percentagePrimary,
        percentageSecondary,
    };
};
